







import Vue from 'vue'
import rafpoly from '../../vendor/polyfills/requestanimationframe'

export default Vue.extend({
  props: {
    forceExpand: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      isExpanded: true,
      defaultDuration: 200
    }
  },
  methods: {
    toggleState() {
      if (this.isExpanded) {
        this.doCollapse()
        return
      }
      this.doExpand()
    },
    getHeight(el: HTMLElement) {
      const origDisplay = el.style.display
      const origHeight = el.style.height

      el.style.display = ''
      el.style.height = 'auto'

      const height = el.offsetHeight

      el.style.display = origDisplay
      el.style.height = origHeight

      return height
    },
    getChildren(): HTMLElement | null {
      let parent: HTMLElement | null = null
      let el = this.$el as HTMLElement | null

      while ((el !== null) && (el.nodeType === 1)) {
        if (el.tagName.toUpperCase() === 'LI') {
          parent = el
          break
        }
        el = el.parentNode as HTMLElement | null
      }

      if (!parent) return null

      return parent.querySelector('ul')
    },
    doCollapse() {
      if (!this.isExpanded) return

      const children = this.getChildren()

      if (!children) return

      this.animate(children, this.getHeight(children), 0, () => children.style.display = 'none')
      this.isExpanded = false
    },
    doExpand() {
      if (this.isExpanded) return

      const children = this.getChildren()

      if (!children) return

      this.animate(children, 0, this.getHeight(children), () => children.style.height = '')
      this.isExpanded = true
    },
    animate(el: HTMLElement, fromHeight: number, toHeight: number, cbDone?: Function) {
      const duration = this.defaultDuration
      let numIterations = duration / (1000 / 60)
      const stepSize = (toHeight - fromHeight) / numIterations
      let currentHeight = fromHeight
      let requestID: number

      el.style.height = fromHeight + 'px'
      el.style.display = ''

      const animation = () => {
        currentHeight += stepSize
        el.style.height = currentHeight + 'px'

        numIterations--

        if (numIterations <= 0) {
          cancelAnimationFrame(requestID)
          el.style.height = toHeight + 'px'
          if (cbDone) cbDone()
          return
        }

        requestID = requestAnimationFrame(animation)
      }

      animation()
    }
  },
  watch: {
    forceExpand(newVal) {
      if (newVal) {
        this.doExpand()
        return
      }
    }
  },
  created(): void {
    // make sure window.requestanimationframe exists
    rafpoly()
  }
})
